<style lang="scss">
* {
  box-sizing: border-box;
}

.console-wrapper {
  background: #fff;
  min-height: 100vh;
  padding: 1.5rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.stat-cards {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;

  .stat-card {
    background: #fff;
    border: 1px solid #e8eaed;
    border-radius: 10px;
    padding: 1rem 1.25rem;
    min-width: 180px;
    flex: 1;

    .stat-label {
      font-size: 0.75rem;
      color: #8c9199;
      margin-bottom: 0.375rem;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 0.03em;
    }

    .stat-value {
      font-size: 1.375rem;
      font-weight: 700;
      color: #1a1d21;
      letter-spacing: -0.02em;
    }

    .stat-actions {
      display: flex;
      gap: 0.375rem;
      margin-top: 0.625rem;

      .stat-btn {
        padding: 0.3125rem 0.625rem;
        font-size: 0.6875rem;
        background: #f0f1f3;
        border: none;
        border-radius: 5px;
        color: #5c5f66;
        cursor: pointer;
        transition: all 0.15s ease;

        &:hover {
          background: #1a1d21;
          color: #fff;
        }
      }
    }
  }
}

.cards-row {
  display: flex;
  gap: 1.25rem;
  max-width: 1200px;
  margin: 0 auto 1.25rem;
}

.card {
  background: #fff;
  // border: 1px solid #e8eaed;
  border-radius: 10px;
  overflow: hidden;
  flex: 1;

  .card-header {
    padding: 0.875rem 1rem;
    border-bottom: 1px solid #f0f1f3;

    h3 {
      font-size: 0.875rem;
      font-weight: 600;
      color: #1a1d21;
      margin: 0;
    }
  }

  .card-body {
    padding: 1.25rem;

    &.user-form {
      display: flex;
      flex-direction: column;
      gap: 0;
    }
  }

  .form-field {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f0f1f3;
    padding: 0.875rem 0;
    gap: 1rem;

    &:first-child {
      padding-top: 0;
    }

    &:last-of-type {
      border-bottom: none;
    }

    .field-label {
      font-size: 0.8125rem;
      color: #5c5f66;
      font-weight: 500;
      min-width: 72px;
      flex-shrink: 0;
    }

    .field-input {
      flex: 1;
      max-width: 260px;
      height: 2.25rem;
      padding: 0 0.75rem;
      font-size: 0.8125rem;
      color: #1a1d21;
      background: #fff;
      border: 1px solid #e0e2e5;
      border-radius: 6px;
      outline: none;
      transition: all 0.15s ease;

      &::placeholder {
        color: #a0a5ad;
      }

      &:hover {
        border-color: #b8bcc4;
      }

      &:focus {
        border-color: #1a1d21;
        box-shadow: 0 0 0 3px rgba(26, 29, 33, 0.06);
      }

      &.disabled {
        background: #f5f6f8;
        color: #8c9199;
        cursor: not-allowed;
        display: flex;
        align-items: center;
      }
    }
  }

  .form-actions-row {
    margin-top: 0.75rem;
    padding-top: 0.75rem;
    border-top: 1px solid #e8eaed;
    display: flex;
    justify-content: flex-end;
    gap: 0.625rem;

    .btn-save {
      padding: 0.5625rem 1.25rem;
      font-size: 0.8125rem;
      font-weight: 500;
      background: #1a1d21;
      color: #fff;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.15s ease;

      &:hover {
        background: #2d3139;
        transform: translateY(-1px);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }
}

.form-grid {
  display: grid;
  gap: 0.875rem;

  .form-row {
    display: grid;
    grid-template-columns: 80px 1fr;
    align-items: center;
    gap: 0.625rem;

    label {
      font-size: 0.75rem;
      color: #5c5f66;
      font-weight: 500;
      text-align: right;
    }
  }
}

.form-actions {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #f0f1f3;
}

.upload-grid {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;

  .upload-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    .upload-label {
      font-size: 0.75rem;
      color: #5c5f66;
      font-weight: 500;
      min-width: 42px;
    }

    .upload-preview {
      width: 88px;
      height: 88px;
      border-radius: 8px;
      border: 1px solid #e8eaed;
      object-fit: cover;
    }

    .upload-btn {
      width: 88px;
      height: 88px;
      border: 1.5px dashed #c5c8ce;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.15s ease;
      background: #fafbfc;

      &:hover {
        border-color: #8c9199;
        background: #f5f6f8;
      }

      .el-icon {
        color: #a0a5ad;
      }
    }
  }
}

.table-wrapper {
  max-width: 1200px;
  margin: 0 auto 1.25rem;
}

.table-section {
  background: #fff;
  border: 1px solid #e8eaed;
  border-radius: 10px;
  overflow: hidden;

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.875rem 1rem;
    border-bottom: 1px solid #f0f1f3;
    background: #fafbfc;

    h3 {
      font-size: 0.875rem;
      font-weight: 600;
      color: #1a1d21;
      margin: 0;
    }

    .add-btn {
      padding: 0.4375rem 0.875rem;
      font-size: 0.75rem;
      font-weight: 500;
      background: #1a1d21;
      color: #fff;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.15s ease;

      &:hover {
        background: #2d3139;
      }
    }
  }

  .table-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0.75rem 1rem;

    &::-webkit-scrollbar {
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f5f6f8;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c5c8ce;
      border-radius: 3px;

      &:hover {
        background: #a0a5ad;
      }
    }
  }
}

.data-table {
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;
  font-size: 0.8125rem;

  th {
    background: #fafbfc;
    padding: 0.4375rem 0.5rem;
    text-align: left;
    font-weight: 600;
    color: #5c5f66;
    border-bottom: 1px solid #e8eaed;
    white-space: nowrap;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;

    &:nth-child(1) {
      width: 85px;
    }

    &:nth-child(2) {
      width: 70px;
    }

    &:nth-child(3) {
      width: 75px;
    }

    &:nth-child(4) {
      width: 140px;
    }

    &:nth-child(5) {
      width: 120px;
    }

    &:nth-child(6) {
      width: 70px;
    }

    &:nth-child(7) {
      width: 130px;
    }

    &:nth-child(8) {
      width: 100px;
    }
  }

  td {
    padding: 0.5rem 0.5625rem;
    color: #1a1d21;
    border-bottom: 1px solid #f0f1f3;
    vertical-align: middle;
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr:hover td {
    background: #fafbfc;
  }

  .host-input {
    width: 100%;
    padding: 0.375rem 0.5rem;
    font-size: 0.75rem;
    border: 1px solid #e0e2e5;
    border-radius: 4px;
    outline: none;
    transition: border-color 0.15s ease;

    &:focus {
      border-color: #1a1d21;
    }
  }
}

.status-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  font-size: 0.6875rem;
  font-weight: 600;
  border-radius: 4px;
  letter-spacing: 0.02em;

  &.status-active {
    background: #d4edda;
    color: #1b5e3b;
  }

  &.status-warning {
    background: #fff3cd;
    color: #7d5a00;
  }

  &.status-danger {
    background: #f8d7da;
    color: #8b1a1a;
  }
}

.action-btns {
  display: flex;
  gap: 0.4375rem;

  .action-btn {
    padding: 0.375rem 0.6875rem;
    font-size: 0.75rem;
    font-weight: 500;
    border-radius: 4px;
    cursor: pointer;
    border: none;
    transition: all 0.15s ease;

    &.btn-renew {
      background: #1a1d21;
      color: #fff;

      &:hover {
        background: #2d3139;
      }
    }

    &.btn-delete {
      background: #fce8e8;
      color: #a12b2b;

      &:hover {
        background: #f8d7da;
      }
    }
  }
}

.table-footer {
  display: flex;
  justify-content: center;
  padding: 0.875rem;
  border-top: 1px solid #f0f1f3;
}

:deep(.el-input__wrapper) {
  box-shadow: none !important;
  border: 1px solid #e0e2e5;
  border-radius: 6px;
  padding: 0 0.75rem;
  height: 2.25rem;
  background: #fff;
  transition: all 0.15s ease;

  &:hover {
    border-color: #b8bcc4;
  }

  &.is-focus {
    border-color: #1a1d21;
    box-shadow: 0 0 0 3px rgba(26, 29, 33, 0.06) !important;
  }

  &.is-disabled {
    background: #f5f6f8;

    .el-input__inner {
      color: #8c9199;
      cursor: not-allowed;
    }
  }
}

:deep(.el-input__inner) {
  font-size: 0.8125rem;
  color: #1a1d21;

  &::placeholder {
    color: #a0a5ad;
  }
}

:deep(.el-button) {
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.8125rem;
  padding: 0.5625rem 1rem;
  transition: all 0.15s ease;
}

:deep(.el-button--primary) {
  background: #1a1d21;
  border-color: #1a1d21;

  &:hover {
    background: #2d3139;
    border-color: #2d3139;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
}

:deep(.el-button--default) {
  background: #fff;
  border-color: #e0e2e5;
  color: #5c5f66;

  &:hover {
    border-color: #b8bcc4;
    color: #1a1d21;
    background: #fafbfc;
  }
}

:deep(.el-dialog) {
  border-radius: 12px;

  .el-dialog__header {
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #f0f1f3;
    margin-right: 0;
  }

  .el-dialog__title {
    font-size: 0.9375rem;
    font-weight: 600;
    color: #1a1d21;
  }

  .el-dialog__body {
    padding: 1.25rem;
  }

  .el-dialog__footer {
    padding: 0.875rem 1.25rem;
    border-top: 1px solid #f0f1f3;
  }
}

.add-empower-dialog {
  .empower-form {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .empower-field {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f0f1f3;
    padding: 0.875rem 0;
    gap: 1rem;

    &:first-child {
      padding-top: 0;
    }

    &:last-of-type {
      border-bottom: none;
    }

    .empower-label {
      font-size: 0.8125rem;
      color: #5c5f66;
      font-weight: 500;
      min-width: 120px;
      flex-shrink: 0;
    }

    .empower-input {
      flex: 1;
      height: 2.25rem;
      padding: 0 0.75rem;
      font-size: 0.8125rem;
      color: #1a1d21;
      background: #fff;
      border: 1px solid #e0e2e5;
      border-radius: 6px;
      outline: none;
      transition: all 0.15s ease;

      &::placeholder {
        color: #a0a5ad;
      }

      &:hover {
        border-color: #b8bcc4;
      }

      &:focus {
        border-color: #1a1d21;
        box-shadow: 0 0 0 3px rgba(26, 29, 33, 0.06);
      }
    }

    .number-input-group {
      display: flex;
      align-items: center;
      gap: 0.625rem;

      .unit-text {
        font-size: 0.8125rem;
        color: #5c5f66;
        white-space: nowrap;
      }
    }

    :deep(.el-select) {
      width: 100%;
      max-width: 320px;
    }

    :deep(.el-input-number) {
      width: 140px;
    }
  }

  .empower-total {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #e8eaed;
    gap: 0.375rem;

    .total-label {
      font-size: 0.8125rem;
      color: #5c5f66;
    }

    .total-price {
      font-size: 1.375rem;
      font-weight: 700;
      color: #dc2626;
    }

    .total-unit {
      font-size: 0.8125rem;
      color: #5c5f66;
    }
  }

  .empower-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.625rem;

    .btn-cancel {
      padding: 0.5625rem 1.125rem;
      font-size: 0.8125rem;
      font-weight: 500;
      background: #fff;
      color: #5c5f66;
      border: 1px solid #e0e2e5;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.15s ease;

      &:hover {
        border-color: #b8bcc4;
        color: #1a1d21;
        background: #fafbfc;
      }
    }

    .btn-primary {
      padding: 0.5625rem 1.25rem;
      font-size: 0.8125rem;
      font-weight: 500;
      background: #1a1d21;
      color: #fff;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.15s ease;

      &:hover {
        background: #2d3139;
        transform: translateY(-1px);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }
}

:deep(.el-select__wrapper) {
  box-shadow: none !important;
  border: 1px solid #e0e2e5;
  border-radius: 6px;
  min-height: 2rem;

  &:hover {
    border-color: #c5c8ce;
  }

  &.is-focused {
    border-color: #1a1d21;
  }
}

:deep(.el-input-number) {
  .el-input__wrapper {
    border-radius: 6px;
  }
}

:deep(.el-pagination) {
  .el-pagination__total {
    font-size: 0.75rem;
    color: #8c9199;
  }

  .btn-prev,
  .btn-next {
    background: #fff;
    border: 1px solid #e0e2e5;
    border-radius: 4px;

    &:hover {
      background: #f5f6f8;
    }
  }

  .el-pager li {
    background: #fff;
    border: 1px solid #e0e2e5;
    border-radius: 4px;
    font-size: 0.75rem;
    min-width: 1.75rem;
    height: 1.75rem;
    line-height: 1.75rem;

    &:hover {
      background: #f5f6f8;
    }

    &.is-active {
      background: #1a1d21;
      color: #fff;
      border-color: #1a1d21;
    }
  }
}
</style>

<template>
  <div class="common-layout" style="padding-right: 0;">
    <el-container style="height: 100vh;width: 100vw;">
      <el-aside style="width: fit-content;">
        <UserHead />
      </el-aside>
      <el-container>
        <el-header style="padding: 0;">
          <HeadTop />
        </el-header>
        <el-main style="padding: 0;overflow: auto;background-color: #fff !important;">
          <div class="console-wrapper">
            <div class="stat-cards">
              <div class="stat-card">
                <div class="stat-label">我的余额</div>
                <div class="stat-value">{{ user_conf.money }}元</div>
                <div class="stat-actions">
                  <span class="stat-btn" @click="puy_money()">在线充值</span>
                  <span class="stat-btn" @click="withdrawalView()">提现</span>
                </div>
              </div>
            </div>

            <div class="cards-row">
              <div class="card">
                <div class="card-header">
                  <h3>用户信息管理</h3>
                </div>
                <div class="card-body user-form">
                  <div class="form-field">
                    <label class="field-label">用户编号</label>
                    <div class="field-input disabled">
                      {{ user_conf.uid }}
                    </div>
                  </div>
                  <div class="form-field">
                    <label class="field-label">用户名</label>
                    <input class="field-input" type="text" v-model="user_conf.username" placeholder="请输入用户名" />
                  </div>
                  <div class="form-field">
                    <label class="field-label">我的上级</label>
                    <div class="field-input disabled">
                      {{ user_conf.higher_uid }}
                    </div>
                  </div>
                  <div class="form-field">
                    <label class="field-label">绑定邮箱</label>
                    <div class="field-input disabled">
                      {{ user_conf.user_email }}
                    </div>
                  </div>
                  <div class="form-field">
                    <label class="field-label">登录密码</label>
                    <input class="field-input" type="password" v-model="user_conf.password" placeholder="***********" />
                  </div>
                  <div class="form-actions-row">
                    <button class="btn-save" @click="openDialog('消息', '您确认要修改用户信息吗', true, 'setUserInfo')">
                      保存修改
                    </button>
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header">
                  <h3>收款信息管理</h3>
                </div>
                <div class="card-body">
                  <div class="upload-grid">
                    <div class="upload-item">
                      <span class="upload-label">微信</span>
                      <el-image v-if="!isNull(user_conf.wxQR_code)" :preview-src-list="[user_conf.wxQR_code]"
                        :src="user_conf.wxQR_code" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" fit="cover"
                        class="upload-preview" />
                      <el-upload :show-file-list="false" class="upload-btn" :action="upload.url" :data="upload.wx_data"
                        :limit="1" :on-exceed="handleExceed" :on-success="handleSuccess"
                        :before-upload="beforeAvatarUpload">
                        <el-icon>
                          <Plus />
                        </el-icon>
                      </el-upload>
                    </div>
                    <div class="upload-item">
                      <span class="upload-label">支付宝</span>
                      <el-image v-if="!isNull(user_conf.zfbQR_code)" :preview-src-list="[user_conf.zfbQR_code]"
                        :src="user_conf.zfbQR_code" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" fit="cover"
                        class="upload-preview" />
                      <el-upload :show-file-list="false" class="upload-btn" :action="upload.url" :data="upload.zfb_data"
                        :limit="1" :on-exceed="handleExceed" :on-success="handleSuccess"
                        :before-upload="beforeAvatarUpload">
                        <el-icon>
                          <Plus />
                        </el-icon>
                      </el-upload>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-wrapper">
              <div class="table-section">
                <div class="table-header">
                  <h3>授权列表</h3>
                  <button class="add-btn" @click="addEmpowerFun('dialog')">添加授权</button>
                </div>
                <div class="table-scroll">
                  <table class="data-table">
                    <thead>
                      <tr>
                        <th>插件名</th>
                        <th>插件版本</th>
                        <th>插件id</th>
                        <th>添加时间</th>
                        <th>授权字段</th>
                        <th>授权者id</th>
                        <th>到期时间</th>
                        <th>操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in empower_data" :key="row.empower_id">
                        <td>{{ row.includes_name }}</td>
                        <td>{{ row.version_name }}</td>
                        <td>{{ row.includes_id }}</td>
                        <td>{{ row.add_date }}</td>
                        <td>
                          <input class="host-input" v-model="row.empower_host"
                            @change="updateHostClick(row.empower_id, row.empower_host)" placeholder="请输入" />
                        </td>
                        <td>{{ row.add_uid }}</td>
                        <td>
                          <span class="status-badge" :class="{
                            'status-active': getEndDateColor(row.end_date) == 1,
                            'status-warning': getEndDateColor(row.end_date) == 2,
                            'status-danger': getEndDateColor(row.end_date) == 3
                          }">
                            {{ row.end_date }}
                          </span>
                        </td>
                        <td>
                          <div class="action-btns">
                            <button class="action-btn btn-delete"
                              v-if="getEndDateColor(row.end_date) === 3 || row.is_free == 1"
                              @click="deleteAuthDialog(row.empower_id)">删除</button>
                            <button class="action-btn btn-renew"
                              @click="renewAuthDialog(row.empower_id, row.includes_id, row.version)">续费</button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="table-footer">
                  <el-pagination v-model:current-page="empower_Conf.currentPage"
                    v-model:page-size="empower_Conf.pageSize" :page-sizes="[10, 25, 50]"
                    :disabled="empower_Conf.disabled" layout="total, sizes, prev, pager, next, jumper"
                    :total="empower_Conf.total" @size-change="sizeChange" @current-change="currentChange" />
                </div>
              </div>
            </div>

            <el-dialog :close-on-click-modal="false" v-model="centerDialog.isShow" :title="centerDialog.title"
              width="500" align-center>
              <span>{{ centerDialog.content }}</span>
              <template #footer>
                <div class="dialog-footer">
                  <el-button @click="centerDialog.isShow = false">关闭</el-button>
                  <el-button type="primary" @click="centerDialogClick(centerDialog.clickBind)">
                    确认
                  </el-button>
                </div>
              </template>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" v-model="trendsDialog.dialogVisible" title="选择等级"
              style="width: fit-content;" align-center>
              <el-form label-position="top" style="width: 40rem;" label-width="auto">
                <el-form-item label="升级等级">
                  <el-select v-model="select_option" placeholder="请选择需要升级的等级">
                    <el-option v-for="(item) in grade_Option" :key="item.grade_id"
                      :label="item.name + '---' + item.price_diff + '元'" :value="item.grade_id" />
                    <el-option v-if="grade_Option.length == 0" label="您已经是最高等级了" />
                  </el-select>
                </el-form-item>
              </el-form>
              <template #footer>
                <div class="dialog-footer">
                  <el-button @click="trendsDialog.dialogVisible = false">关闭</el-button>
                  <el-button type="primary" @click="centerDialogClick('gradeUp')">
                    确认升级
                  </el-button>
                </div>
              </template>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" v-model="addEmpower_dialog.dialogVisible" title="添加授权" align-center
              class="add-empower-dialog">
              <div class="empower-form">
                <div class="empower-field" v-show="!appConf.isRenew">
                  <label class="empower-label">授权插件</label>
                  <el-select v-model="includes_data.select_option" @change="getPluginVersions" placeholder="请选择插件">
                    <el-option v-for="(item) in includes_data.includes_list" :key="item.id"
                      :label="item.id + '---' + item.platform + '---' + item.name" :value="item.id" />
                    <el-option v-if="includes_data.includes_list.length == 0" disabled>--暂无插件/您不是任何插件的代理--</el-option>
                  </el-select>
                </div>

                <div class="empower-field" v-show="!appConf.isRenew">
                  <label class="empower-label">功能版本</label>
                  <el-select v-model="version_data.select_option" @change="onVersionChange" placeholder="请选择功能版本"
                    :disabled="version_data.version_list.length === 0">
                    <el-option v-for="(item) in version_data.version_list" :key="item.version"
                      :label="item.version + '--' + item.versionName" :value="item.version" />
                    <el-option v-if="version_data.version_list.length === 0 && includes_data.select_option"
                      disabled>--该插件无版本信息--</el-option>
                  </el-select>
                </div>

                <div class="empower-field">
                  <label class="empower-label">授权时长单位</label>
                  <el-select v-model="time_meal_data.select_option" @change="setTimeMeal(time_meal_data.select_option)"
                    placeholder="请选择时长单位" :disabled="time_meal_data.time_meal_list.length === 0">
                    <el-option v-for="(item) in time_meal_data.time_meal_list" :key="item.meal_id"
                      :label="item.time_unit + '---每' + item.time_unit + ' ' + item.price + '元'"
                      :value="item.meal_id" />
                  </el-select>
                </div>

                <div class="empower-field">
                  <label class="empower-label">授权时长</label>
                  <div class="number-input-group">
                    <el-input-number v-model="time_meal_data.num" :min="time_meal_data.min" :max="time_meal_data.max" />
                    <span v-if="time_meal_data.unit != ''" class="unit-text">{{ time_meal_data.unit }}</span>
                  </div>
                </div>

                <div class="empower-field" v-show="!appConf.isRenew">
                  <label class="empower-label">绑定邮箱</label>
                  <input class="empower-input" type="text" v-model="addEmpower_dialog.user_email"
                    placeholder="若是普通用户则填写当前绑定邮箱" />
                </div>

                <div class="empower-field" v-show="!appConf.isRenew">
                  <label class="empower-label">授权字段(域名/ip等)</label>
                  <input class="empower-input" type="text" v-model="addEmpower_dialog.host" placeholder="请输入域名或IP" />
                </div>

                <div class="empower-total" v-if="time_meal_data.unit != ''">
                  <span class="total-label">总计:</span>
                  <span class="total-price">{{ getTimePrice }}</span>
                  <span class="total-unit">元</span>
                </div>
              </div>
              <template #footer>
                <div class="dialog-footer empower-footer">
                  <button class="btn-cancel" @click="addEmpower_dialog.dialogVisible = false">关闭</button>
                  <button class="btn-primary" v-show="!appConf.isRenew"
                    @click="openDialog('消息', '您确定要添加此授权吗？您需要支付' + getTimePrice + '元', true, 'addEmpower')">
                    添加授权
                  </button>
                  <button class="btn-primary" v-show="appConf.isRenew"
                    @click="openDialog('消息', '您确定要续费此授权吗？您需要支付' + getTimePrice + '元', true, 'renewEmpower')">
                    续费授权
                  </button>
                </div>
              </template>
            </el-dialog>
            <el-dialog v-model="balanceRechargeDialog.isShow" title="充值" width="500" align-center>
              <div style="padding: 1rem 0;">
                <div style="margin-bottom: 1rem;">
                  <span style="font-size: 0.875rem;color: #374151;">充值金额</span>
                  <el-input :min="balanceRechargeDialog.checkType.min" :max="balanceRechargeDialog.checkType.max"
                    v-model="balanceRechargeDialog.money" style="width: 80%;margin-left: 1rem;" size="large"
                    :placeholder="'单笔充值范围:' + balanceRechargeDialog.checkType.min + '--' + balanceRechargeDialog.checkType.max"
                    type="number" />
                </div>
                <div>
                  <span style="font-size: 0.875rem;color: #374151;">支付方式</span>
                  <el-select v-model="balanceRechargeDialog.type" placeholder="支付方式" size="large"
                    style="width: 80%;margin-left: 1rem;" @change="payTypeChange">
                    <el-option v-for="item in balanceRechargeDialog.types" :key="item.type"
                      :label="item.name + '(手续费' + item.fee + ')'" :value="item.type" />
                  </el-select>
                </div>
              </div>
              <template #footer>
                <div class="dialog-footer">
                  <el-button @click="balanceRechargeDialog.isShow = false">取消</el-button>
                  <el-button type="primary" @click="toRecharge()">
                    确定
                  </el-button>
                </div>
              </template>
            </el-dialog>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script lang="ts" setup>
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { ref, onMounted, reactive, computed, getCurrentInstance } from 'vue';
import { isNull, getEmpower, EmpowerResponse } from '@/utils/publicMethods';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import { ElMessage, } from 'element-plus'
import type { UploadProps } from 'element-plus'
import { Grade } from '@/types/gradeInterface'
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'
import { Platform } from '@element-plus/icons-vue/dist/types';
const baseURL = process.env.VUE_APP_API_BASE_URL;

var labelPosition = 'right'
var user_conf = ref({
  uid: '',
  username: '',
  user_email: '',
  higher_uid: "",
  password: "",
  money: "",
  higher_email: "",
  grade_id: -1,
  grade_name: "",
  grade_content: "",
  sell_price: 0,
  wxQR_code: '',
  zfbQR_code: ''
})
var appConf = ref({
  isRenew: false,
  empower_id: -1,
})
var balanceRechargeDialog = ref({
  isShow: false,
  money: "",
  types: [],
  type: "",
  checkType: { min: 0, max: 0 }
})
var deleteAuth_id = -1;
const getTimePrice = computed(() => {
  const product = time_meal_data.value.price * time_meal_data.value.num;
  return product.toFixed(2);
})

var grade_data = reactive<Grade[]>([]);

const select_option = ref()
var empower_data = ref([
  {
    includes_name: '',
    id: "",
    includes_id: "",
    add_date: '',
    empower_host: '',
    higher_uid: "",
    end_date: ""
  },
])
var updateHost_data = ref({
  empower_id: -1,
  update_host: ""
})
var centerDialog = ref({
  isShow: false,
  title: "info",
  content: "content",
  clickBind: ""
})
var trendsDialog = ref({
  dialogTitle: "",
  dialogVisible: false
})
var addEmpower_dialog = ref({
  dialogTitle: "",
  dialogVisible: false,
  select_option: "",
  time_Option: [],
  user_email: "",
  host: ""
})
var includes_data = ref({
  select_option: "",
  includes_list: [{
    id: "",
    grade_name: "",
    name: "",
    platform: ""
  }
  ]
})
interface grade_dataIn {
  grade_id: number,
  name: string,
  content: string,
  sell_price: number,
  higher_reward: number,
  isPoss: boolean,
  price_diff: number,
}
var grade_Option = ref<grade_dataIn[]>([]);
const validateUsername = (rule: any, value: any, callback: any) => {
  const regExp = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
  if (regExp.test(value)) {
    callback(new Error('不能有特殊字符'));
  } else {
    callback();
  }
}
const rules = {
  password: [
    { min: 6, max: 20, message: '长度在6-20位', trigger: ['change', 'blur'] },
  ],
  username: [
    { min: 1, max: 10, message: '长度在1-10位', trigger: ['change', 'blur'] },
    { validator: validateUsername, trigger: ['blur', 'change'] },
  ]
}
const userInfo_form = ref(null)
const openDialog = (title: string, content: string, isShow: boolean, clickBind: string) => {
  if (isShow == false) {
    centerDialog.value.isShow = false
  }
  else {
    centerDialog.value.title = title
    centerDialog.value.content = content
    centerDialog.value.isShow = true
    centerDialog.value.clickBind = clickBind
  }
}
const centerDialogClick = (act: string) => {
  switch (act) {
    case "setUserInfo":
      submitForm('setUserInfo');
      break;
    case 'updateHost':
      submitForm('updateHost');
      break;
    case 'gradeUp':
      submitForm('gradeUp');
      break;
    case 'addEmpower':
      addEmpowerFun('post');
      break;
    case 'renewEmpower':
      renewEmpowerFun();
      break;
    case 'deleteAuth':
      deleteAuth(deleteAuth_id)
      break;
    default:
      break;
  }
}
const updateHostClick = (empower_id: number, update_host: string) => {
  updateHost_data.value.empower_id = empower_id
  updateHost_data.value.update_host = update_host
  openDialog('消息', '您确认要修改此授权吗', true, 'updateHost')
}
const renewAuthDialog = (empower_id: number, includes_id: string, version: number) => {
  appConf.value.isRenew = true;
  addEmpower_dialog.value.dialogVisible = true
  includes_data.value.select_option = includes_id;
  appConf.value.empower_id = empower_id;
  getTimeMeal(includes_id, version + "");

}
const renewEmpowerFun = () => {
  openLoading();
  centerDialog.value.isShow = false
  const headers = {
    'token': localStorage.getItem("token")
  }
  // const data = new FormData()
  const data = {
    empower_id: appConf.value.empower_id
    , time_act: time_meal_data.value.meal_id
    , time_num: time_meal_data.value.num
  }
  // data.append("empower_id", appConf.value.empower_id+"")
  // data.append("time_act", time_meal_data.value.meal_id + "")
  // data.append("time_num", time_meal_data.value.num + "")
  axios.post(baseURL + "/userApi/renewSelfEmpower", data, { timeout: 10000, headers: headers })
    .then(async (res) => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        addEmpower_dialog.value.dialogVisible = false
        ElMessage.success(res.data.msg)
        await getUserInfo();
      }
      else {
        ElMessage.error(res.data.msg)
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('续费失败：' + err.message)
    })
}
const getUserInfo = () => {
  openLoading()
  const headers = {
    'token': localStorage.getItem("token")
  }
  axios.get(baseURL + "/userApi/getUserInfo", { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        user_conf.value = res.data.data
        user_conf.value.higher_email = res.data.data.higher_email
        localStorage.setItem("user_conf", JSON.stringify(user_conf.value))
        empower_data.value = res.data.empower_data;
        empower_Conf.value.total = res.data.total_empower
        if (res.data.total_empower < empower_Conf.value.pageSize) {
          empower_Conf.value.disabled = true
        }
      }
      else {
        ElMessage.error(res.data.msg)
        if (res.data.code == 401) {
          ElMessage.error(res.data.msg)
          setTimeout(() => {
            location.href = "/Login"
          }, 500);
        }
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('获取用户信息失败：' + err.message)
    })
}
const submitForm = (act: string) => {
  openLoading()
  centerDialog.value.isShow = false
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token")
  }
  switch (act) {
    case "setUserInfo":
      if (!user_conf.value.username) {
        fullscreenLoading.close()
        ElMessage.error('请输入用户名')
        return
      }
      data.append("act", "setUserInfo");
      if (user_conf.value.password) {
        data.append("password", user_conf.value.password);
      }
      if (user_conf.value.username) {
        data.append("username", user_conf.value.username);
      }
      if (user_conf.value.user_email) {
        data.append("user_email", user_conf.value.user_email);
      }
      axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == 401) {
            ElMessage.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            ElMessage.success(res.data.msg)
            setTimeout(() => {
              location.reload()
            }, 1000);
          }
          else {
            ElMessage.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          ElMessage.error('请求失败：' + err.message)
        })
      break;
    case "updateHost":
      data.append("act", "updateHost");
      if (updateHost_data.value.empower_id && updateHost_data.value.empower_id != -1) {
        data.append("empower_id", String(updateHost_data.value.empower_id));
      }
      if (updateHost_data.value.update_host && updateHost_data.value.update_host != "") {
        data.append("update_host", updateHost_data.value.update_host);
      }
      axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == 401) {
            ElMessage.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            ElMessage.success(res.data.msg)
            setTimeout(() => {
              location.reload()
            }, 1000);
          }
          else {
            ElMessage.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          ElMessage.error('请求失败：' + err.message)
        })
      break;
    case 'gradeUp':
      data.append("act", "gradeUp")
      data.append("grade_id", select_option.value)
      axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          // openGradeUpDialog(false, "");
          if (res.data.code == 401) {
            ElMessage.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            ElMessage.success(res.data.msg)
            setTimeout(() => {
              location.reload()
            }, 1000);
          }
          else {
            ElMessage.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          // openGradeUpDialog(false, "");
          console.log(err)
          ElMessage.error('请求失败：' + err.message)
        })
      break;

    default:
      break;
  }
}
const puy_money = () => {
  balanceRechargeDialog.value.isShow = true;
  axios.get(baseURL + "/pay/payType", { timeout: 10000, headers: { 'token': localStorage.getItem("token") } })
    .then(res => {
      if (res.data.code == 200) {
        balanceRechargeDialog.value.types = res.data.data.list
      } else {
        ElMessage.error(res.data.msg)
      }
    }).catch(err => {
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })

}

const payTypeChange = (value: any) => {
  for (let i = 0; i < balanceRechargeDialog.value.types.length; i++) {
    const item = balanceRechargeDialog.value.types[i];
    if (item.type == value) {
      value = item
      break;
    }
  }
  balanceRechargeDialog.value.checkType = value;
}
const store = useStore();
const router = useRouter();
const toRecharge = () => {
  const money = parseInt(balanceRechargeDialog.value.money);
  const min = balanceRechargeDialog.value.checkType.min;
  const max = balanceRechargeDialog.value.checkType.max;
  if (money < min || money > max) {
    ElMessage.error('充值金额超出范围：[' + min + ',' + max + ']');
    return;
  }
  openLoading()
  axios.post(baseURL + "/pay/balanceRecharge", {
    name: "余额充值",
    money: balanceRechargeDialog.value.money,
    type: balanceRechargeDialog.value.type
  }, { timeout: 10000, headers: { 'token': localStorage.getItem("token") } })
    .then(res => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        balanceRechargeDialog.value.isShow = false;
        const url = res.data.data.url;
        if (!isNull(url)) {
          window.open(res.data.data.url, '_blank');
        } else {
          const outTradeNo = res.data.data.outTradeNo;
          sessionStorage.setItem("outTradeNo", outTradeNo);
          window.open("/alipayDMF", '_blank');
        }
      } else {
        ElMessage.error(res.data.msg)
      }
    }).catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })
}
const withdrawalView = () => {
  location.href = '/Withdrawal'
}
const handleExceed: UploadProps['onExceed'] = (files, uploadFiles) => {
  ElMessage.warning(
    `限制上传一个, 你选择了${files.length} 个文件,`
  )
}
const upload = ref({
  url: baseURL + "/xiaochuFile/uploadImg",
  wx_data: { 'act': 'uploadWxQR', 'token': localStorage.getItem('token') },
  zfb_data: { 'act': 'uploadZfbQR', 'token': localStorage.getItem('token') },
  wx_code: "",
  zfb_code: '',
})
const beforeAvatarUpload: UploadProps['beforeUpload'] = (rawFile) => {
  if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png' && rawFile.type !== 'image/gif' && rawFile.type !== 'image/jpg') {
    ElMessage.error('只能上传jpeg,png,gif,jp文件')
    return false
  } else if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('文件大小不能超过 2MB!')
    return false
  }
  return true
}
const handleSuccess = (response: any) => {
  if (response.code == 200) {
    upload.value.wx_code = ""
    upload.value.zfb_code = ""
    ElMessage.success(response.msg)
    if (response.data.includes("zfb_qr")) {
      user_conf.value.zfbQR_code = response.data + "?t=" + Date.now()
    }
    else {
      user_conf.value.wxQR_code = response.data + "?t=" + Date.now()
    }
  }
  else {
    ElMessage.error(response.msg)
  }
}
const empower_Conf = ref({
  total: 0,
  pageSize: 10,
  currentPage: 1,
  disabled: false,
})
const sizeChange = (val: number) => {
  empower_Conf.value.pageSize = val
  getEmpower1()
}
const currentChange = (val: number) => {
  empower_Conf.value.currentPage = val
  getEmpower1()
}
const getEmpower1 = async () => {
  const res: EmpowerResponse = await getEmpower(empower_Conf.value.currentPage, empower_Conf.value.pageSize);
  if (res.code == 200) {
    empower_Conf.value.total = res.total_empower
    if (res.data.total_empower < empower_Conf.value.pageSize) {
      empower_Conf.value.disabled = true
    }
    empower_data.value = res.data
  }
}
const addEmpowerFun = (act: string) => {
  if (act == 'dialog') {
    appConf.value.isRenew = false;
    addEmpower_dialog.value.dialogVisible = true;
    time_meal_data.value.time_meal_list = [];
    version_data.value.version_list = [];
    version_data.value.select_option = "";

    openLoading();
    const headers = {
      'token': localStorage.getItem("token") || ''
    };

    axios.get(baseURL + "/userApi/getIncludesAll", { timeout: 10000, headers: headers })
      .then(res => {
        fullscreenLoading.close();
        if (res.data.code == 200) {
          includes_data.value.includes_list = res.data.data;
        } else {
          ElMessage.error(res.data.msg);
        }
      })
      .catch(err => {
        fullscreenLoading.close();
        console.log(err);
        ElMessage.error('获取插件列表失败：' + err.message);
      });
  } else if (act == 'post') {
    openLoading();
    centerDialog.value.isShow = false;
    const headers = {
      'token': localStorage.getItem("token") || ''
    };

    const data = new FormData();
    data.append("includes_id", includes_data.value.select_option);
    data.append("host", addEmpower_dialog.value.host);
    data.append("email", addEmpower_dialog.value.user_email);
    data.append("time_act", time_meal_data.value.meal_id + "");
    data.append("time_num", time_meal_data.value.num + "");

    // Add version if selected
    if (version_data.value.select_option) {
      data.append("version", version_data.value.select_option);
    }

    axios.post(baseURL + "/userApi/addSelfEmpower", data, { timeout: 10000, headers: headers })
      .then(res => {
        fullscreenLoading.close();
        if (res.data.code == 200) {
          addEmpower_dialog.value.dialogVisible = false;
          ElMessage.success(res.data.msg);
          getUserInfo(); // Refresh user info after successful authorization
        } else {
          ElMessage.error(res.data.msg);
        }
      })
      .catch(err => {
        fullscreenLoading.close();
        console.log(err);
        ElMessage.error('添加授权失败：' + err.message);
      });
  }
}

var time_meal_data = ref({
  select_option: "",
  time_meal_list: [
    {
      meal_id: "",
      min: 1,
      max: 1,
      price: 0,
      time_unit: "",
    }
  ],
  num: 1,
  min: 1,
  max: 1,
  unit: "",
  price: 1,
  meal_id: ""
})
var version_data = ref({
  select_option: "",
  version_list: [] as { version: string; versionName: string }[]
})

// Add method to get plugin versions
const getPluginVersions = (soft_id: string) => {
  // Reset version selection and time meal data
  version_data.value.select_option = "";
  version_data.value.version_list = [];
  time_meal_data.value.select_option = "";
  time_meal_data.value.time_meal_list = [];

  // If no plugin selected, return
  if (!soft_id) return;

  openLoading();
  const headers = {
    'token': localStorage.getItem("token") || ''
  };

  const data = {
    soft_id: soft_id
  };

  axios.post(baseURL + "/userApi/getSoftVersion", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close();
      if (res.data.code == 200) {
        version_data.value.version_list = res.data.data.list || [];
        // If there's only one version, auto-select it
        if (res.data.data.list && res.data.data.list.length === 1) {
          version_data.value.select_option = res.data.data.list[0].version;
          onVersionChange(res.data.data.list[0].version);
        }
      } else {
        ElMessage.error(res.data.msg || '获取版本信息失败');
      }
    })
    .catch(err => {
      fullscreenLoading.close();
      console.log(err);
      ElMessage.error('获取版本信息失败：' + err.message);
    });
}

// Add method to handle version change
const onVersionChange = (version: string) => {
  // Reset time meal selection
  time_meal_data.value.select_option = "";
  time_meal_data.value.time_meal_list = [];

  if (version && includes_data.value.select_option) {
    getTimeMeal(includes_data.value.select_option, version);
  }
}
const getTimeMeal = (includes_id: string, version?: string) => {
  openLoading();
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token") || ''
  };

  data.append("includes_id", includes_id);
  data.append("act", "getTimeMeal");

  // Add version if provided
  if (version) {
    data.append("version", version);
  }

  axios.post(baseURL + "/userApi/getInfo", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close();
      if (res.data.code == 401) {
        ElMessage.error('您没有登录');
        setTimeout(() => {
          location.href = "/Login";
        }, 1000);
      } else if (res.data.code == 200) {
        time_meal_data.value.time_meal_list = res.data.data;
      } else {
        ElMessage.error(res.data.msg);
      }
    })
    .catch(err => {
      fullscreenLoading.close();
      console.log(err);
      ElMessage.error('请求失败：' + err.message);
    });
}
const deleteAuthDialog = (empower_id: number) => {
  deleteAuth_id = empower_id
  openDialog('消息', '您确定要删除此授权吗？此操作不可撤销', true, 'deleteAuth')
}
const deleteAuth = (empower_id: number) => {
  openLoading()
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token")
  }
  data.append("id", empower_id + "")
  axios.post(baseURL + "/userApi/deleteAuth", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      centerDialog.value.isShow = false
      if (res.data.code == 401) {
        ElMessage.error('您没有登录')
        setTimeout(() => {
          location.href = "/Login"
        }, 1000);
      }
      else if (res.data.code == 200) {
        ElMessage.success(res.data.msg);
        setTimeout(() => {
          getUserInfo()
        }, 200);
      }
      else {
        ElMessage.error(res.data.msg)
      }
    })
    .catch(err => {
      centerDialog.value.isShow = false
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })
}
const setTimeMeal = (select_option: string) => {
  var element = time_meal_data.value.time_meal_list.filter(item => item.meal_id == select_option);
  time_meal_data.value.num = 1
  time_meal_data.value.min = element[0].min
  time_meal_data.value.max = element[0].max
  time_meal_data.value.unit = element[0].time_unit
  time_meal_data.value.price = element[0].price
  time_meal_data.value.meal_id = element[0].meal_id
}
//计算结束时间还有多久
const getEndDateColor = (end_date: string) => {
  var endDate = new Date(end_date);
  if (endDate.getTime() < new Date().getTime()) {
    return 3;
  }
  if (endDate.getTime() < new Date().getTime() + 1000 * 60 * 60 * 24 * 3) {
    return 2;
  }
  return 1;
}

onMounted(async () => {
  const globalProperties = getCurrentInstance().appContext.config.globalProperties;
  window.ResizeObserver = globalProperties.$customResizeObserver;
  await getUserInfo()
})
</script>
